export const templateItems = [
  {
    group: 'Spin dan dapatkan hadiahnya!',
    label: 'Jersey Persib Beckham',
    weight: 3,
    order: 0
  },
  {
    group: 'Spin dan dapatkan hadiahnya!',
    label: 'Motor Beat 2025',
    weight: 1,
    order: 1
  },
  {
    group: 'Spin dan dapatkan hadiahnya!',
    label: 'Tumbler Theyni',
    weight: 6,
    order: 2
  },
  {
    group: 'Spin dan dapatkan hadiahnya!',
    label: 'Voucher Belanja Rp100.000',
    weight: 8,
    order: 3
  },
  {
    group: 'Spin dan dapatkan hadiahnya!',
    label: 'Voucher Belanja Rp50.000',
    weight: 10,
    order: 4
  },
  {
    group: 'Spin dan dapatkan hadiahnya!',
    label: 'Voucher Diskon 10%',
    weight: 10,
    order: 5
  },
  {
    group: 'Spin dan dapatkan hadiahnya!',
    label: 'Paket Bundling Theyni',
    weight: 5,
    order: 6
  },
  {
    group: 'Spin dan dapatkan hadiahnya!',
    label: 'Voucher Diskon Rp15.000',
    weight: 13,
    order: 7
  }
];
